import React from 'react';
import {
  ButtonToolbar,
  Col,
  ControlLabel,
  FormGroup,
  Row,
} from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../FieldGroup.jsx';
import GroupSearchSelect from '../../GroupSearchSelect.jsx';
import { getOrgTermsContent } from '../../../content/utils.js';

function GroupForm(props) {
  const { groups, onSelectParentGroup, selectedParentGroupId } = props;

  const selectedGroups = selectedParentGroupId
    ? { [selectedParentGroupId]: true }
    : {};

  const handleGroupSelect = (group) => {
    if (selectedParentGroupId === group.id) {
      onSelectParentGroup(null);
    } else {
      onSelectParentGroup(group.id);
    }
  };

  const findGroupById = (groupList, targetId) => {
    for (const group of groupList) {
      if (group.id === targetId) {
        return group;
      }
      if (group.children?.length > 0) {
        const found = findGroupById(group.children, targetId);
        if (found) return found;
      }
    }
    return null;
  };

  const selectedGroup = selectedParentGroupId
    ? findGroupById(groups, selectedParentGroupId)
    : null;
  const title = selectedGroup
    ? selectedGroup.name
    : 'Select the Group, Team or Department';

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="text-muted m-b-32">
            Group will appear in Organization Structure and current{' '}
            {getOrgTermsContent('initiative')}
          </div>
        </Col>
        <Col xs={12}>
          <Field
            id="groupFormName"
            name="name"
            label="Group Name"
            placeholder="Enter the Group Name"
            type="text"
            component={FieldGroup}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <FormGroup>
            <ControlLabel>Parent Group</ControlLabel>
            <ButtonToolbar>
              <GroupSearchSelect
                groups={groups}
                selectedGroups={selectedGroups}
                onSelectGroup={handleGroupSelect}
                title={title}
                className="btn-block"
              />
            </ButtonToolbar>
          </FormGroup>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default GroupForm;
